import "./card.css";

interface CardProps {
    title: string;
    value: string | number;
    subtitle?: string;
    icon?: React.ReactNode;
}

export default function Card({
    title,
    value,
    subtitle,
    icon
}: CardProps) {
    return (
        <div className="card">
            <div className="card-header">
                <span>{title}</span>
                {icon}
            </div>
            <div className="card-value">
                {value}
            </div>
            {subtitle && (
                <div className="card-subtitle">
                    {subtitle}
                </div>
            )}
        </div>
    );
}